import React, { Component } from 'react'
import Swal from "sweetalert2";
import "../css/general-style.css"
import '../css/table-responsive.css'
import "../css/pickingSystem-style.css"
import Select from 'react-select';
import { AiOutlineComment } from "react-icons/ai"
import { FiTrash, FiSave, FiCheckCircle } from "react-icons/fi";
import { getValueCookie } from '../services/cookieService'
import { create_Delete_Update_Information, getInformationWithData, saveJsonData, getInformationWithDataV3 } from '../services/CABE'
import { validateSession } from '../services/auth/sessionValidation';
import { confirmCloseAlert } from '../functions/alerts';
import { getPrintHeaderCompany } from '../functions/companyInformation';
import { pricesFormat } from '../functions/pricesFormat';
import { DateFormatMAS90, FormatQueryReturnDateForReport, getActualDateUTC, getDateYearMonthDayDash } from '../functions/dateFormat';
import { DecimalPart, getPriceMargin, getPurePriceMargin, MobileDisp, NumberFormat, OrderArray, validateNumbersForQuantitys } from '../functions/generalFunctions';
import { getIndexElement } from '../functions/searchInObject';
import CustomerList from '../components/CustomerList'
import LoadingWindow from '../components/LoadingWindow';
import SalesOrderList from '../components/SalesOrderList';
import { OrderPDF } from '../components/OrderPDF';
import SmallModal from '../components/SmallModal';
import SearchUPC from '../components/SearchUPC';
import Catalogue2 from '../components/Catalogue2.0/Catalogue2.0';
import { DownloadOrderPDF } from '../components/DownloadOrderPDF';

import axios from "axios";
import { buildSalesOrderNo } from '../functions/documentPrefix';

// Temporal check if theres a blocked item
import { blockedItems } from '../components/Catalogue2.0/blockedItems'


export default class SalesOrder extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {
        disable: false,
        isInputFocused: false,
        ConfirmSave: 0,
        ProductList: [],
        ProductsForAltitude: [],
        Products: [],
        SalesOrder: {
            Customer: {
                AddressLine1: '',
                City: '',
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                PriceLevel: undefined,
                SalespersonNo: '',
                State: '',
                TelephoneNo: '',
                ZipCode: '',
                uniqueTrack: '',
            },
            NoOrder: '',
            Type: 'S',
            TotalQuantityOrdered: 0,
            TotalCost: 0,
            TotalWeight: 0,
            Date: getDateYearMonthDayDash(),
            Warehouse: '000',
            Packing: null,
            WeightOption: null,
            MAS90Status: 0,
            TotalLines: 0,
            Duplicate: false,
            status: null,

        },
        Balance: {
            HeaderBalance: [],
            TermsCode: '',
            TotalBalance: 0,
            SelectedInvoice: '',
            Detail: []
        },

        companyPrintHeader: getPrintHeaderCompany(),
        showModal1: false,
        confirmMargin: false,
        NotZeroUnitPrice: true,
        selectOptions1: [

            { value: 'Transparent Stretch Wrap', label: 'Transparent Stretch Wrap' },
            { value: 'Black Stretch Wrap', label: 'Black Stretch Wrap' },
            { value: 'Not Packing (Customer Collect) ', label: 'Not Packing (Customer Collect)' }
        ],
        selectOptions2: [
            { value: '003', label: 'B&B Miami Warehouse Price Level 4' },//4
            { value: '000', label: 'Mayaland Atlanta Warehouse Price Level 3' }//5
        ],
        selectOptions3: [
            { value: 'Weighed', label: 'Weighed' },
            { value: 'No need to be Weighed', label: 'No need to be Weighed' }
        ],
        enableEdit: false,
        isMayalandOrder: true,
        isNotNewSO: true,
        newSalesOrder: false

    }

    setupBeforeUnloadListener = () => {
        if (this.state.Products.length > 0) {
            window.addEventListener("beforeunload", (ev) => {
                ev.preventDefault();
                ev.returnValue = '';
                return this.doSomethingBeforeUnload();
            });
        }
    };

    async getNewCorrelativeSalesOrder() {
        this.clearSalesOrder()
        const data = {
            type: 'SalesOrder',
            idCompany: getValueCookie('CompanyId')
        }
        const result = await getInformationWithDataV3('/sales/get/correlativeV2', data)
        const activeSession = validateSession(result)
        
        // Request successful
        if (result.status.code === 1 && activeSession) {
            const temporal = this.state.SalesOrder
            temporal.NoOrder = buildSalesOrderNo(result.data[0].correlative)
            this.setState({ SalesOrder: temporal })
        }
    }

    valueRadioButton = async e => {
        let stat = e.target.value
        const temporal = this.state.SalesOrder
        temporal.Type = stat
        this.setState({ SalesOrder: temporal })
    }

    calculateTotals() {
        let totalQuantity = 0
        let totalCost = 0
        let totalWeight = 0
        let totalPrice = 0
        const temporal = this.state.Products
        const temporal2 = this.state.SalesOrder

        for (const item of temporal) {

            totalPrice += Number(item.LastTotalUnitCost) * Number(item.quantityOrdered)
            totalQuantity += Number(item.quantityOrdered)
            totalCost += Number(item.totalCost)
            totalWeight += Number(item.quantityOrdered) * Number(item.ShipWeight)
        }

        temporal2.TotalQuantityOrdered = totalQuantity
        temporal2.TotalCost = totalCost
        temporal2.TotalWeight = totalWeight
        temporal2.Customer.uniqueTrack = getPriceMargin(totalCost, totalPrice, temporal2.Customer.PriceLevel)
        this.setState({ SalesOrder: temporal2 })
        this.AutoSave()
    }
    
    async getItemList() {
        const data = {
            idcompany: "3"
        }
        try {
            let response = await getInformationWithData('/Items/get', data);
            this.setState({ProductList: response.data})
        } catch (error) {
            console.log(error)
        }
    }
    
    setAltPrice(item){
        let altitudePrice = item.LastTotalUnitCost / 0.95;
        altitudePrice = altitudePrice / (1 - (item.MarkUp / 100));
        return altitudePrice;
    }

    checkMinPrice(temporal, newValue) {
        const productList = this.state.ProductList;
        const originalItem = productList.find(item => item.itemCode === temporal.itemCode);
        const newPrice = Number(newValue.target.value);
        const n1Price = originalItem.UnitPrice

        if(newPrice < n1Price) {
            let altitudePrice = this.setAltPrice(originalItem);

            if(altitudePrice < n1Price) {
                altitudePrice = n1Price;
            }

            const totalCost = temporal.quantityOrdered * altitudePrice;

            this.setState((prevState) => ({
                Products: prevState.Products.map((item) => 
                    item.itemCode === temporal.itemCode
                    ? { ...item, UnitPrice: Number(altitudePrice.toFixed(2)), totalCost: totalCost}
                    : item
                )
            }))
            alert(`The lower price for this product is $${ NumberFormat(pricesFormat(n1Price)) }`)
            return false
        }
        return true
    }

    onTargetChange(e, product) {
        let newPrice = e.target.value;
        this.setState((prevstate) => {
            const updatedProducts = prevstate.Products.map((item) => {
                if(item.itemCode === product.itemCode) {
                    return { ...item, UnitPrice: newPrice };
                }
                return item
            });
            return { Products: updatedProducts }
        })
    }

    onTarget = async (e, item) => {
        const temporal = this.state.Products
        const ident = e.target.id.split('_')
        const index = temporal.indexOf(item)

        if (index !== -1) {
            if (ident[0] === "quantityOrderedSalesOrder") {
                    let quant = Number(e.target.value)

                    if (!validateNumbersForQuantitys(quant)) {
                        let parteDecimal = 1 - DecimalPart(quant)
                        quant += parteDecimal
                        document.getElementById(e.target.id).value = quant
                    }

                    temporal[index].quantityOrdered = Number(quant)
                    temporal[index].totalCost = (Number(quant) * Number(temporal[index].UnitPrice))
                    this.setState({ Products: temporal, ConfirmSave: 0 })
                    this.calculateTotals()
            } else if (ident[0] === "unitPriceSalesOrder") {
                temporal[index].UnitPrice = Number(e.target.value)
                temporal[index].totalCost = (Number(e.target.value) * Number(temporal[index].quantityOrdered))
                if (getValueCookie('CompanyId') === '6') {
                    // temporal[index].Comment = "BOX:" + getPriceMargin(temporal[index].UnitPrice, temporal[index].unitCost, this.state.SalesOrder.Customer.PriceLevel)
                    temporal[index].Comment = "BOX:" + this.state.SalesOrder.Customer.CustomerName
                    temporal[index].PureMargin = getPurePriceMargin(temporal[index].UnitPrice, temporal[index].unitCost)
                    
                }
                if (getValueCookie('CompanyId') === '6') {
                    if(this.checkMinPrice(temporal[index], e) && getValueCookie('TypeUser') !== '1') {
                        this.setState({ Products: temporal, ConfirmSave: 0 })
                        this.calculateTotals()
                    } else {
                    }
                } else {
                    this.setState({ Products: temporal, ConfirmSave: 0 })
                    this.calculateTotals()
                }
            }
        }
        await this.AutoSave()
        this.setState({ isInputFocused: false });
    }

    checkInputFocus = () => {
        this.setState({ isInputFocused: true });
    }

    clearSalesOrder() {
        const clear = {
            ConfirmSave: 0,
            confirmMargin: false,
            NotZeroUnitPrice: true,
            Customer: {
                AddressLine1: '',
                City: '',
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                PriceLevel: undefined,
                SalespersonNo: '',
                State: '',
                TelephoneNo: '',
                ZipCode: '',
                uniqueTrack: '',
            },
            TotalLines: 0,
            NoOrder: '',
            Type: 'S',
            TotalQuantityOrdered: 0,
            TotalCost: 0,
            TotalWeight: 0,
            Date: getDateYearMonthDayDash(),
            Warehouse: '000',
            Packing: null,
            WeightOption: null,
            MAS90Status: 0,
            Duplicate: false,
        }
        this.setState({ SalesOrder: clear, Products: [], enableEdit: false })
        localStorage.removeItem('SalesOrderSave')
    }

    addComentary(item) {
        let comm = item.Comment
        Swal.fire({
            title: 'Product: ' + item.itemCode,
            html: `<div class='textAreaGeneral textAreaComment'>
                    <textarea id='comentOfSalesOrder' rows="10" cols="50">${comm}</textarea>
                   </div>
            `,
            backdrop: true,
            showCancelButton: true,
            confirmButtonText: 'Save Commentary',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                const temporal = this.state.Products
                const index = temporal.indexOf(item)
                if (index !== -1) {
                    const coment = Swal.getPopup().querySelector('#comentOfSalesOrder').value
                    temporal[index].Comment = coment
                    this.setState({ Products: temporal })
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
        this.AutoSave()
    }

    removeProduct(item) {
        let temporal = this.state.Products
        const index = temporal.indexOf(item)

        if (index !== -1) {
            temporal[index].quantityOrdered = 0
            temporal[index].totalCost = 0
            temporal[index].Visible = 0

            for (let a = 0; a < temporal.length; a++) {
                document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
                document.getElementById("unitPriceSalesOrder_" + a).value = temporal[a].UnitPrice
            }
            
            this.setState({ Products: temporal })
            this.calculateTotals()
        }
        this.AutoSave()
    }

    refreshInputs() {
        const temporal = this.state.Products
        for (let a = 0; a < temporal.length; a++) {
            document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
            document.getElementById("unitPriceSalesOrder_" + a).value = temporal[a].UnitPrice
        }
    }

    AsignLineSequence() {
        const head = this.state.SalesOrder
        if (getValueCookie('CompanyId') === '6') {
            const temporal = OrderArray(JSON.parse(JSON.stringify(this.state.Products)), 'IdCompany', true)

            let confirmMargin = false
            let NotZeroUnitPrice = true
            let count = 1
            let activeLines = 0
            for (const item of temporal) {
                item.LineSequence = count
                item.quantityShipped = 0
                count++
                if (!confirmMargin) {
                    confirmMargin = item.PureMargin > 20 ? false : true
                }
                if (item.UnitPrice <= 0 && item.Visible === 1) {
                    NotZeroUnitPrice = false
                }
                if (item.Visible !== 0) {
                    activeLines++
                }
            }

            head.TotalLines = activeLines
            this.setState({ confirmMargin: confirmMargin, NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
            return temporal
        } else {
            const temporal = this.state.Products
            let NotZeroUnitPrice = true
            let count = 1
            let activeLines = 0
            for (const item of temporal) {
                item.LineSequence = count
                item.quantityShipped = 0
                count++
                if (item.UnitPrice <= 0 && item.Visible === 1) {
                    NotZeroUnitPrice = false
                }
                if (item.Visible !== 0) {
                    activeLines++
                }
            }
            head.TotalLines = activeLines
            this.setState({ NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
            return temporal
        }
    }

    detailToPrint() {
        let items = []
        this.state.Products.forEach(element => {
            if (element.Visible === 1) {
                element.abbreviatedDesc = (element.completeDesc && element.completeDesc !== "null") ? element.completeDesc : element.abbreviatedDesc
                items.push(element)
            }
        });
        return items
    }

    async updateMayalandSO(altitudeSO) {
        let mayalandTemporal = altitudeSO;
        mayalandTemporal.idCompany = "3"
        mayalandTemporal.company = 'Mayaland Atlanta'
        mayalandTemporal.Customer.CustomerNo = '0016027';
        mayalandTemporal.Detail = this.updateAltitudePrices(mayalandTemporal.Detail);
        
        // const result = await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)
        // Same BOX comment backv2 adds to the Mayaland mirror of an Altitude order, but it only
        // recognizes 'AL' numbers — set it here so 'AS' orders get it too.
        mayalandTemporal.Detail.forEach(item => { item.Comment = `BOX: ${mayalandTemporal.Customer.CustomerName}` })

        await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)
    }

    updateAltitudePrices(productList) {
        productList.forEach(element => {
            const altitudePrice = element.LastTotalUnitCost / 0.95;
            element.UnitPrice = Number(altitudePrice.toFixed(2))
        });
        return productList;
    }

    async checkSalesOrderStatus(SONumber){
        const data = {
            SalespersonNo: getValueCookie('SalesPerson'),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
        }
        const response = await getInformationWithData('/sales/get/header', data);
        const salesOrderList = response.data;

        const getSalesOrder = salesOrderList.find(obj => obj.SalesOrderNo === SONumber)
        if(getSalesOrder){
            return getSalesOrder.Status;
        }
        return 0
    }

    async createSalesOrder(LoadMas90) {
        await this.AsignLineSequence()
        Swal.fire({
            title: 'Are you sure to save this order?',
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showCancelButton: true,
            confirmButtonText: 'Yes, please',
            cancelButtonText: 'No, cancel!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const temporal = JSON.parse(JSON.stringify(this.state.SalesOrder))
                temporal.Detail = this.AsignLineSequence()
                temporal.idCompany = getValueCookie('CompanyId')
                temporal.username = getValueCookie('userName')
                temporal.company = getValueCookie('Company')
                temporal.OrderType = 'SalesOrder'
                temporal.MAS90Status = LoadMas90
                temporal.Packing = this.state.SalesOrder.Packing + ";" + this.state.SalesOrder.WeightOption

                await saveJsonData('/store/json', temporal)

                if (getValueCookie('CompanyId') !== '6' || (getValueCookie('CompanyId') === '6' && !this.state.confirmMargin)) {

                    if ((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption) || getValueCookie('CompanyId') === '6') {
                        if (this.state.NotZeroUnitPrice) {
                            const result = await create_Delete_Update_Information('/sales/set/order', temporal)
                            if (result.status.code === 1) {
                                this.setState({ ConfirmSave: this.state.Products.length })
                                await this.SaveAndPrint()
                                await confirmCloseAlert('correct', 'The order was saved successfully!')
                                localStorage.removeItem('SalesOrderSave')
                                if (getValueCookie('CompanyId') === '6'){
                                    // await this.updateCompanyPrices(temporal)
                                    this.updateMayalandSO(temporal)
                                }
                                // salesOrderDoubleCheck(temporal)
                            } else {
                                confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')
                            }
                        } else {
                            Swal.fire({
                                title: 'Some products have Unit Price on Zero.\nPlease Fix that!',
                                text: "",
                                icon: 'warning',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: true,
                                confirmButtonText: 'OK',
                                cancelButtonText: 'No, cancel!',
                            })
                        }
                    } else {
                        if (!this.state.SalesOrder.Packing) {
                            Swal.fire({
                                title: 'You need select a Type of Packing to Save this Sales Order!',
                                text: "",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: false,
                                confirmButtonText: 'Ok'
                            })
                        } else {
                            Swal.fire({
                                title: 'You need select if the order are Weighed or No need to be Weighed',
                                text: "",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: false,
                                confirmButtonText: 'Ok'
                            })
                        }
                    }
                } else {
                    Swal.fire({
                        title: 'Some products have Problem with the Unit Tracking.\nDo you like to continue?',
                        text: "",
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, please',
                        cancelButtonText: 'No, cancel!',
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            if (this.state.NotZeroUnitPrice) {
                                const result = await create_Delete_Update_Information('/sales/set/order', temporal)
                                if (result.status.code === 1) {
                                    this.setState({ ConfirmSave: this.state.Products.length })
                                    await this.SaveAndPrint()
                                    await confirmCloseAlert('correct', 'The order was saved successfully!')
                                    localStorage.removeItem('SalesOrderSave')
                                    if (getValueCookie('CompanyId') === '6'){
                                        // await this.updateCompanyPrices(temporal)
                                        this.updateMayalandSO(temporal)
                                    }
                                } else {
                                    confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')

                                }
                            } else {
                                Swal.fire({
                                    title: 'Some products have Unit Price on Zero.\nPlease Fix that!',
                                    text: "",
                                    icon: 'warning',
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    showCancelButton: false,
                                    confirmButtonText: 'OK',
                                })
                            }
                        }
                    })
                }
            }
            if((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption)){
                this.setState({enableEdit: true})
            }
            if (getValueCookie('CompanyId') === '6'){
                this.setState({enableEdit: true})
            }
        })
    }

    componentDidMount() {
        if (localStorage.getItem('SalesOrderSave')) {
            let infoRec = JSON.parse(localStorage.getItem('SalesOrderSave'));
            if (infoRec) {
                this.setState({ Products: infoRec.Products, SalesOrder: infoRec.SalesOrder })
            }

            if(infoRec.SalesOrder.Customer.CustomerNo === '0016027' && getValueCookie('CompanyId') !== '6'){
                this.setState({isMayalandOrder: false})
            }
        }
        window.addEventListener('storage', this.handleStorageChange);
        if (getValueCookie('CompanyId') === '6') {
            this.getItemList();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
    }


    AutoSave() {
        localStorage.setItem('SalesOrderSave', JSON.stringify(this.state))
    }

    TypeInLetters(type) {
        if (type === 'S') {
            return 'Standard'
        } else {
            return 'Quote'
        }
    }

    handleModalOpen = (modal) => {
        this.setState({ [modal]: true })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
    }

    handleStorageChange = async (event) => {
        if (event.key === 'SalesOrderSave') {
            let infoRec = JSON.parse(localStorage.getItem('SalesOrderSave'));
            if (infoRec) {
                if (infoRec.SalesOrder.NoOrder === this.state.SalesOrder.NoOrder) {
                    await this.setState({ Products: infoRec.Products, SalesOrder: infoRec.SalesOrder })
                    await this.refreshInputs()
                }
            }
        }
    }

    getTotalBalance() {
        let currentBalance = 0

        this.state.Balance.HeaderBalance.forEach(line => {
            currentBalance += Number(line.Balance)
        });

        const temporal = this.state.Balance
        temporal.TotalBalance = currentBalance
        this.setState({ Balance: temporal })
    }

    async getDetailBalance(LineBalance) {
        const data = {
            idCompany: Number(getValueCookie('CompanyId')),
            InvoiceNo: LineBalance.InvoiceNo
        }
        this.ModalLoading.current.showState(true);

        // const baseUrl = "https://apiportalmanager.mayaland.store";
        // const prefix = getValueCookie('apiPrefix');
        // const apiPrefix = prefix ? prefix : '';

        // let query = "/invoice/history/getInvoicePayment";
        
        // const url = baseUrl + apiPrefix + query;
        // const result = await axios.post(`${url}${query}`, data);

        const result = await getInformationWithData('/invoice/history/getInvoicePayment', data)
        if (result.status.code === 1) {
            const temporal = this.state.Balance
            temporal.Detail = result.data
            temporal.SelectedInvoice = LineBalance.InvoiceNo
            this.setState({ Balance: temporal })
        }
        this.ModalLoading.current.showState(false);
    }

    validationNewSalesOrder() {
        if (this.state.Products.length !== this.state.ConfirmSave) {
            Swal.fire({
                title: 'Are you sure to Start a new Sales Order, you have a Sales Order open and unsave?',
                icon: 'info',
                showDenyButton: true,
                confirmButtonText: `Yes, I'm sure.`,
                denyButtonText: `Not`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.getNewCorrelativeSalesOrder()
                }
            })
        } else {
            this.getNewCorrelativeSalesOrder()
        }
        this.setState({isNotNewSO: false, newSalesOrder: true})
    }

    onChangeSelects = async (e, id) => {
        const temporal = this.state.SalesOrder
        switch (id) {
            case "Warehouse":
                temporal.Warehouse = e.value
                this.setState({ SalesOrder: temporal })
                this.changePriceLevel(e.value)
                break;
            case "Packing":
                temporal.Packing = e.value
                this.setState({ SalesOrder: temporal })
                break;
            case "Weight":
                temporal.WeightOption = e.value
                this.setState({ SalesOrder: temporal })
                break;
            default:
                break;
        }
    }

    changePriceLevel(id) {
        const temporal = this.state.SalesOrder
        switch (id) {
            case "003":
                temporal.Customer.PriceLevel = '4'
                this.setState({ SalesOrder: temporal })
                break;
            case "000":
                temporal.Customer.PriceLevel = '3'
                this.setState({ SalesOrder: temporal })
                break;

            default:
                break;
        }
    }

    async OnlySaveSO() {
        const temporal = this.state.SalesOrder
        temporal.Detail = this.AsignLineSequence()
        temporal.idCompany = getValueCookie('CompanyId')
        temporal.username = getValueCookie('userName')
        temporal.company = getValueCookie('Company')
        temporal.OrderType = 'SalesOrder'
        await create_Delete_Update_Information('/sales/set/order', temporal)
    }

    async TemporalSaveSystem() {
        const temporal = this.state.SalesOrder
        temporal.Detail = this.AsignLineSequence()
        temporal.idCompany = getValueCookie('CompanyId')
        temporal.username = getValueCookie('userName')
        temporal.company = getValueCookie('Company')
        temporal.OrderType = 'SalesOrder'
        if (temporal.idCompany === '6') {
            await create_Delete_Update_Information('/sales/post/savetemporal', temporal)
        }
    }

    async SaveAndPrint() {
        let button = document.getElementById('SalesOrderPrint')
        if (button) {
            button.click()
        }
    }

    disable() {
        this.setState({ disable: true })
    }

    async reOpenSalesOrder(SalesOrderNo) {
            // Sweet alert to confirm
            Swal.fire({
                title: 'Reopen this order?',
                text: "You need to reopen this order to make changes.",
                icon: 'warning',
                confirmButtonColor: '#ff5470',
                cancelButtonColor: '#a8b3c7',
                showCancelButton: true,
                confirmButtonText: 'Reopen',
                cancelButtonText: 'Cancel',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const data = {
                        OrderNo: SalesOrderNo,
                        Status: '1',
                        idCompany: 3,
                        MODE: 'S/O'
                    }
                    // Update order status
                    await create_Delete_Update_Information('/picklist/set/PickListState', data)
                    this.clearSalesOrder()
                }
            })
        }

    async deleteSalesOrder(SalesOrderNo) {
            // Sweet alert to confirm
            Swal.fire({
                title: 'Delete this order?',
                text: "This action cannot be undone.",
                icon: 'warning',
                confirmButtonColor: '#ff5470',
                cancelButtonColor: '#a8b3c7',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    // const data = {
                    //     OrderNo: SalesOrderNo,
                    // }
                    // await create_Delete_Update_Information('/picklist/set/PickListState', data)
                    this.clearSalesOrder()
                }
            })
        }

    render() {
        return (
            <div className="container-fluid">
                <LoadingWindow ref={this.ModalLoading} />
                <div className='text-center my-4'>
                    <h2 className='display-4 fw-bold inventory-title'>Sales Order</h2>
                    <p className='lead text-muted inventory-subtitle'>To start please select a sales order or create a new one</p>
                </div>
                
                {getValueCookie('CompanyId') === '3' && this.state.SalesOrder.Customer.CustomerNo === '0016027'?
                    <div className="alert alert-primary" role="alert">
                            <h4>Consultation-Only View</h4>
                            <p>This order is managed by Altitude Distribution Corp.</p>
                            <p>Any updates or corrections must be made directly in the respective portal. This view is for consultation purposes only.</p>
                            <hr />
                            <p>If you have any questions, please contact IT support.</p>
                            
                        </div>
                    :<div></div>
                }
                {this.state.SalesOrder.status === 1?
                <div className="alert alert-warning" role="alert">
                    <h4>Sales Order in progress</h4>
                    <p>This order is in progress.</p>
                    <p>Please let the warehouse personnel know about any changes. They need to refresh/reload this sales order to apply the new updates.</p>
                    <hr />
                    <p>If you have any questions, please contact IT support.</p>
                    
                </div>
                :<></>}
                <div className='row pt-1 pb-2'>
                    <div className='col-sm-12'>
                        <div className='row'>
                            <div className='col-sm-12 pb-4 InputTextBolder text-center'>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 mb-3">
                                        <button type="button" onClick={() => this.validationNewSalesOrder()} className="btn blueButton btn-lg w-100"><FiCheckCircle /> New Order</button>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <SalesOrderList disabled={false} headerName='' nombrePadre="SalesOrderListSO" Padre={this} />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-6 mb-3'>
                                <div className='card'>
                                    <div className="card-body">
                                        <div className='row pt-2 pb-2'>
                                            <div className='col-sm-12'>
                                                <div className='row'>
                                                    <div className='col-5 InputTextBolder text-end'><p>Order No: </p></div>
                                                    <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.NoOrder}</div>
                                                </div>
                                            </div>
                                            <div className='col-sm-12'>
                                                <div className='row'>
                                                    <div className='col-5 InputTextBolder text-end'><p>Person No: </p></div>
                                                    <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.Customer.SalespersonNo}</div>
                                                </div>
                                            </div>
                                            <div className='col-sm-12'>
                                                <div className='row'>
                                                    <div className='col-5 InputTextBolder text-end'><p>Price Level: </p></div>
                                                    <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.Customer.PriceLevel}</div>
                                                </div>
                                            </div>
                                            {/* Validate if the sales order is finished */}
                                            {this.state.SalesOrder.NoOrder && this.state.SalesOrder.status === 2  && getValueCookie('TypeUser') === '1' && (
                                                <div className='col-sm-12'>
                                                    <div className='row d-flex justify-content-center pt-4'>
                                                        <div className='col-sm-12 col-md-6'>
                                                            <button type='button'  onClick={() => this.reOpenSalesOrder(this.state.SalesOrder.NoOrder)} className='btn btn-warning btn-lg'>Set As In Progress</button>
                                                        </div>
                                                        {/* <div className='col-sm-12 col-md-6'>
                                                            <button type='button'  onClick={() => this.reOpenSalesOrder(this.state.SalesOrder.NoOrder)} className='btn btn-danger btn-lg'>Delete Sales Order</button>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <div className='card'>
                                    <div className="card-body">
                                        <div className='col-sm-12 mb-3'>
                                            <div className='row'>
                                            <div className='col-12 pt-3 d-flex justify-content-center'>
                                                    <div className="form-check me-5">
                                                        <input disabled={this.state.enableEdit} className="form-check-input textRadioButtonSize" value={'S'} onChange={this.valueRadioButton} id="SalesOrderStand" checked={this.state.SalesOrder.Type === 'S'} type="radio" name="typeSalesOrder" />
                                                        <label className="form-check-label textRadioButtonSize InputTextBolderSimple" htmlFor="SalesOrderStand"  >
                                                            Standard
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input disabled={this.state.enableEdit} hidden={this.state.SalesOrder.Type === 'S' && this.state.isNotNewSO && this.state.status !== null} className="form-check-input textRadioButtonSize" value={'Q'} onChange={this.valueRadioButton} id="SalesOrderQuot" checked={this.state.SalesOrder.Type === 'Q'} type="radio" name="typeSalesOrder" />
                                                        <label hidden={this.state.SalesOrder.Type === 'S' && this.state.isNotNewSO && this.state.status !== null} className="form-check-label textRadioButtonSize InputTextBolderSimple" htmlFor='SalesOrderQuot' >
                                                            Quote
                                                        </label>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12' hidden={getValueCookie('CompanyId') === '6'}>
                                            <div className='row' >
                                                <div className='col-12 InputTextBolder text-start'><p>Type of Packaging: </p></div>
                                                <div className='col-12 pb-3'>
                                                    <Select value={this.state.selectOptions1[(getIndexElement(this.state.selectOptions1, 'value', this.state.SalesOrder.Packing))]} isDisabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit} className='fs-4 text-start' menuPortalTarget={document.body} menuPosition='fixed' styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={this.state.selectOptions1} onChange={(e) => this.onChangeSelects(e, "Packing")} placeholder="Select Type of Packaging" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12' hidden={getValueCookie('CompanyId') === '6'}>
                                            <div className='row' >
                                                <div className='col-12 InputTextBolder text-start'><p>Need to be Weighed?: </p></div>
                                                <div className='col-12 pb-3'>
                                                    <Select value={this.state.selectOptions3[(getIndexElement(this.state.selectOptions3, 'value', this.state.SalesOrder.WeightOption))]} isDisabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit} className='fs-4 text-start' menuPortalTarget={document.body} menuPosition='fixed' styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={this.state.selectOptions3} onChange={(e) => this.onChangeSelects(e, "Weight")} placeholder="Select Type of Packaging" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* control sale order final*/}

                {/* customer details inicio */}
                <div className='row pt-1 pb-2'>
                    <div className='col-sm-12'>
                        <div className='row my-4 text-center d-flex justify-content-center'>
                            <div className='col-sm-6 col-4'>
                                <CustomerList disabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit || this.state.SalesOrder.status === 2} headerName='Customer' nombrePadre="SalesOrder" Padre={this} />
                            </div>
                        </div>
                    </div>
                    <div className='card'>
                        <div className="card-body">
                            <div className="row">
                                <div className='col-sm-6'>
                                    <div className='row'>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>Customer No: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.CustomerNo}</div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>Name: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.CustomerName}</div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>Address Line: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.AddressLine1}</div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>City: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.City}</div>
                                            </div>
                                        </div>
                                        <div hidden={getValueCookie('CompanyId') !== '6'} className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>Unique Tracking: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.uniqueTrack}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-6'>
                                    <div className='row'>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>Zip Code: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.ZipCode}</div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>State: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.State}</div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>Telphone No: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.TelephoneNo}</div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-6 InputTextBolder text-end'><p>Email Address: </p></div>
                                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.EmailAddress}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* customer details final */}

                <div className='row pb-2'>
                    <div hidden={Number(getValueCookie('SubCompanyId')) !== 5}>
                        <div className='col-sm-12 InputTextBolder'><p>Warehouse: </p></div>
                        <div className='col-sm-12 pb-3'>
                            <Select value={this.state.selectOptions2[(getIndexElement(this.state.selectOptions2, 'value', this.state.SalesOrder.Warehouse))]} isDisabled={false} className='fs-4 text-start' options={this.state.selectOptions2} onChange={(e) => this.onChangeSelects(e, "Warehouse")} placeholder="Select Warehouse" />
                        </div>
                    </div>
                    <div className='col-sm-6 pt-2'>

                        <div className="input-group input-group-lg flex-nowrap">
                            <SearchUPC ComponentName={'SalesOrder'} disabled={this.state.SalesOrder.Customer.CustomerNo === '' || this.state.enableEdit || this.state.SalesOrder.status === 2} Padre={this} priceLevel={this.state.SalesOrder.Customer.PriceLevel} />
                        </div>
                    </div>
                    
                    <div className='col-sm-6 pt-2 mb-3'>
                        <div className='row'>
                            <div className='col-sm-6'>
                                {/* Catalog without validations */}
                                {/* <Catalogue2 Customer={this.state.SalesOrder.Customer} hidden={false} id='Catalogue2' PriceLevel={this.state.SalesOrder.Customer.PriceLevel} Array={'Products'} nombrePadre={"SalesOrder"} colorButton='purpleButton' Padre={this} titleButton='Open Catalogue' needPrice={getValueCookie('SalesPerson') === '0010' ? false : true} needCost={getValueCookie('SalesPerson') === '0010' ? true : false} productList={'ProductList'}/> */}
                                
                                <Catalogue2 Customer={this.state.SalesOrder.Customer} hidden={false} id='Catalogue2' PriceLevel={this.state.SalesOrder.Customer.PriceLevel} Array={'Products'} nombrePadre={"SalesOrder"} colorButton='purpleButton' Padre={this} disabled={this.state.SalesOrder.Customer.CustomerNo === '' || this.state.enableEdit || this.state.SalesOrder.status === 2} titleButton='Open Catalogue' needPrice={getValueCookie('SalesPerson') === '0010' ? false : true} needCost={getValueCookie('SalesPerson') === '0010' ? true : false} productList={'ProductList'}/>
                            </div>
                            <div className='col-sm-6'>
                                {
                                    MobileDisp() ?
                                        <OrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                            companyLogo={getValueCookie('DocumentsLogo')}
                                            OrderTitle="Sales Order"
                                            contactInfo={this.state.companyPrintHeader}
                                            OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                                "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                                "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                                "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                                "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                                "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                                "State:", this.state.SalesOrder.Customer.State, "", ""
                                            ]}
                                            headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                            bodyTable={this.detailToPrint()}
                                            headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                            bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                            styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                            comment={""}
                                            breakpoint={52}
                                            keysDecimalFormat={["UnitPrice", "totalCost"]}
                                            disabled={this.state.SalesOrder.Customer.CustomerNo === '' || this.state.Products.length === 0}
                                        />
                                        :
                                        <DownloadOrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                            companyLogo={getValueCookie('DocumentsLogo')}
                                            OrderTitle="Sales Order"
                                            contactInfo={this.state.companyPrintHeader}
                                            OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                                "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                                "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                                "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                                "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                                "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                                "State:", this.state.SalesOrder.Customer.State, "", ""
                                            ]}
                                            docname={this.state.SalesOrder.NoOrder}
                                            headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                            bodyTable={this.detailToPrint()}
                                            headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                            bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                            styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                            comment={""}
                                            breakpoint={52}
                                            keysDecimalFormat={["UnitPrice", "totalCost"]}
                                            disabled={this.state.SalesOrder.Customer.CustomerNo === '' || this.state.Products.length === 0}
                                        />
                                }
                            </div>
                        </div>
                    </div>

                </div>
                {/* products details inicio*/}
                <div className='row'>
                    <div className='col-sm-12 tableFixHead'>
                        <table className='table align-middle table-hover'>
                            <thead className='table-dark thead'>
                                <tr>
                                    <th className='text-center'>Item  Code</th>
                                    <th className='text-center'>Description</th>
                                    <th className='text-center'>Quantity</th>
                                    <th className='text-center'>Weight</th>
                                    <th className='text-center'>Total Weight</th>
                                    <th className='text-center'>Unit Price</th>
                                    <th className='text-center'>Total</th>
                                    <th className='text-center'></th>
                                    <th className='text-center'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.Products.map((item, i) => (
                                    <tr key={i} hidden={item.Visible === 0} className={item.duplicate ? item.duplicate : (item.UnitPrice <= 0 ? 'bg-warning' : '')}>
                                        <td className='text-center'>{item.itemCode}</td>
                                        <td className='text-start'>{(item.completeDesc !== "null" && item.completeDesc) ? item.completeDesc : item.abbreviatedDesc}</td>
                                        <td>
                                            <div className="input-group  input-group-lg">
                                                <input disabled={this.state.enableEdit || this.state.SalesOrder.status === 2} type="number" id={'quantityOrderedSalesOrder_' + i} min={0} defaultValue={item.quantityOrdered} onChange={(e) => this.onTarget(e, item)} className="form-control text-center inputResize" onWheel={(e) => e.target.blur()} />
                                            </div>
                                        </td>
                                        <td className='text-center textTableSize text-secondary' >{NumberFormat(pricesFormat(item.ShipWeight)) + ' lbs'}</td>
                                        <td className='text-center textTableSize text-secondary'> {NumberFormat(pricesFormat(item.quantityOrdered * item.ShipWeight)) + ' lbs'}</td>
                                        <td >
                                            <div className="input-group input-group-lg flex-nowrap">
                                                <span className="input-group-text">$</span>
                                                <input disabled={this.state.enableEdit || blockedItems.has(item.itemCode)} id={'unitPriceSalesOrder_' + i} min={0} step="0.01" defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTargetChange(e, item)} value={item.UnitPrice} onBlur={(e) => this.onTarget(e, item)} onFocus={this.checkInputFocus} className="form-control text-end inputResize" />
                                                {/* <input hidden={getValueCookie('userName') !== 'josue.contreras'} disabled={this.state.enableEdit || (getValueCookie('userName') !== 'josue.contreras' && getValueCookie('TypeUser') !== 1)} id={'unitPriceSalesOrder_' + i} min={0} step="0.01" defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTargetChange(e, item)} value={item.UnitPrice} onBlur={(e) => this.onTarget(e, item)} onFocus={this.checkInputFocus} className="form-control text-end inputResize" /> */}
                                                {/* <td hidden={getValueCookie('userName') === 'josue.contreras'} className='text-start'>{item.UnitPrice}</td> */}
                                            </div>
                                        </td>
                                        <td className='text-end textTableSize text-success'> $ {NumberFormat(Number(item.totalCost).toFixed(2))}</td>
                                        <td>
                                            <div className="d-grid gap-1">
                                                <button disabled={this.state.enableEdit || this.state.SalesOrder.status === 2} type="button" onClick={() => this.addComentary(item)} className="btn grayButton btn-lg text-wrap"> <AiOutlineComment /> </button>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-grid gap-2">
                                                <button disabled={this.state.enableEdit || this.state.SalesOrder.status === 2} type="button" onClick={() => this.removeProduct(item)} className="btn redButton btn-lg"><FiTrash /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className='tfoot'>
                                <tr className='bg-dark text-white'>
                                    <td></td>
                                    <td className='text-center textTableSize'>Totals</td>
                                    <td className='text-center textTableSize'>{NumberFormat(this.state.SalesOrder.TotalQuantityOrdered)}</td>
                                    <td></td>
                                    <td className='text-center textTableSize'>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalWeight) + ' lbs')} </td>
                                    <td className='text-end textTableSize'>$</td>
                                    <td className='text-end textTableSize'>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                {/* products details final */}

                {/* pdf order inicio */}
                <div className='row pb-2 d-flex justify-content-center'>
                    <div className='col-10'>
                        <div className='row d-flex justify-content-center'>
                            <div className='col-sm-12 col-md-6 mb-3'>
                                <div className="d-grid gap-2">
                                    <button hidden={this.state.enableEdit} disabled={this.state.Products.length === 0 || this.state.isInputFocused || !this.state.isMayalandOrder  || this.state.SalesOrder.status === 2} type="button" onClick={() => this.createSalesOrder(1)} className="btn greenButton btn-lg"><FiSave /> Save Order and Print</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* pdf order final */}

                {/* modal Balance inicio*/}
                <SmallModal centered={false} size={'xl'} title={'Balance: ' + this.state.SalesOrder.Customer.CustomerName} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
                    <div className='row pt-2'>
                        <div className='col-sm-12 pb-2'>
                            <h3>Terms Code: {this.state.Balance.TermsCode}</h3>
                        </div>
                        <div className='col-sm-12 tableFixHead'>
                            <table className='table table-hover text-center'>
                                <thead className='thead'>
                                    <tr className='bg-dark'>
                                        <th>Invoice No</th>
                                        <th>Date</th>
                                        <th>Due Date</th>
                                        <th>Payment Delay Days</th>
                                        <th>Customer Name</th>
                                        <th>Sales Person</th>
                                        <th></th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.Balance.HeaderBalance.map((element, e) => (
                                            <tr className={element.InvoiceNo === this.state.Balance.SelectedInvoice ? 'bg-warning' : ''} onClick={() => this.getDetailBalance(element)} key={e}>
                                                <td className='text-start'>{element.InvoiceNo}</td>
                                                <td>{element.InvoiceDate}</td>
                                                <td>{element.InvoiceDueDate}</td>
                                                <td>{element.PaymentDelayDays}</td>
                                                <td>{this.state.SalesOrder.Customer.CustomerName}</td>
                                                <td>{element.SalespersonNo}</td>
                                                <td>$</td>
                                                <td className='text-end'>{NumberFormat(pricesFormat(element.Balance))}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot className='tfoot'>
                                    <tr className='table-dark'>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>TOTAL:</td>
                                        <td>$</td>
                                        <td className='text-end'>{NumberFormat(pricesFormat(this.state.Balance.TotalBalance))}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div className='col-sm-12'>
                            <h3 className='text-start'>Detail: {this.state.Balance.SelectedInvoice}</h3>
                        </div>
                        <div className='col-sm-12 tableFixHead'>
                            <table className='table table-hover text-center'>
                                <thead className='thead'>
                                    <tr>
                                        <th>Invoice No</th>
                                        <th>Invoice Type</th>
                                        <th>Transaction Type</th>
                                        <th>Transaction Date</th>
                                        <th></th>
                                        <th>Transaction Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.Balance.Detail.map((element, e) => (
                                            <tr key={e}>
                                                <td className='text-start'>{element.InvoiceNo}</td>
                                                <td>{element.InvoiceType}</td>
                                                <td>{element.TransactionType}</td>
                                                <td>{DateFormatMAS90(element.TransactionDate)}</td>
                                                <td className='text-end'>$</td>
                                                <td className='text-end'>{NumberFormat(pricesFormat(element.TransactionAmt))}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot className='tfoot'>
                                </tfoot>
                            </table>
                        </div>

                        <div className='col-sm-6 pt-2'>
                            {
                                MobileDisp() ?
                                    <OrderPDF id={"CurrentBalancePrintSalesOrder"} colorButton="blackButton" title="Sales Order Print"
                                        companyLogo={getValueCookie('DocumentsLogo')}
                                        OrderTitle="Current Balance"
                                        contactInfo={this.state.companyPrintHeader}
                                        OrderInfo1={[
                                            "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Print By:", getValueCookie('userName'),
                                            "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                            "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Terms Code:", this.state.Balance.TermsCode,
                                            "Address:", this.state.SalesOrder.Customer.AddressLine1, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                            "City", this.state.SalesOrder.Customer.City, "", ""
                                        ]}
                                        headerTable={["Invoice No", "Date", "Due\nDate", "Payment Delay Days", "Customer\nName", "Sales\nPerson", "", "Balance"]}
                                        bodyTable={this.state.Balance.HeaderBalance}
                                        headerBodyTable={["InvoiceNo", "InvoiceDate", "InvoiceDueDate", "PaymentDelayDays", "CustomerName", "SalespersonNo", "dolar", "Balance"]}
                                        bottomInfo={["", "", "", "", "", "TOTAL", "$", NumberFormat(pricesFormat(this.state.Balance.TotalBalance))]}
                                        styleColumns={["ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaCantidades", "ColumnaTextoLargo2", "ColumnaCantidades", "Dolar", "ColumnaPrecios"]}
                                        hidden={false}
                                        comment={""}
                                        keysDecimalFormat={["Balance"]}
                                        breakpoint={28}
                                        disabled={false}
                                        titleButton='Print Balance'
                                    />
                                    :
                                    <DownloadOrderPDF id={"CurrentBalancePrintSalesOrder"} colorButton="blackButton" title="Sales Order Print"
                                        companyLogo={getValueCookie('DocumentsLogo')}
                                        docname={'Balance ' + this.state.SalesOrder.Customer.CustomerName}
                                        OrderTitle="Current Balance"
                                        contactInfo={this.state.companyPrintHeader}
                                        OrderInfo1={[
                                            "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Print By:", getValueCookie('userName'),
                                            "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                            "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Terms Code:", this.state.Balance.TermsCode,
                                            "Address:", this.state.SalesOrder.Customer.AddressLine1, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                            "City", this.state.SalesOrder.Customer.City, "", ""
                                        ]}
                                        headerTable={["Invoice No", "Date", "Due\nDate", "Payment Delay Days", "Customer\nName", "Sales\nPerson", "", "Balance"]}
                                        bodyTable={this.state.Balance.HeaderBalance}
                                        headerBodyTable={["InvoiceNo", "InvoiceDate", "InvoiceDueDate", "PaymentDelayDays", "CustomerName", "SalespersonNo", "dolar", "Balance"]}
                                        bottomInfo={["", "", "", "", "", "TOTAL", "$", NumberFormat(pricesFormat(this.state.Balance.TotalBalance))]}
                                        styleColumns={["ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaCantidades", "ColumnaTextoLargo2", "ColumnaCantidades", "Dolar", "ColumnaPrecios"]}
                                        hidden={false}
                                        comment={""}
                                        keysDecimalFormat={["Balance"]}
                                        breakpoint={28}
                                        disabled={false}
                                        titleButton='Print Balance'
                                    />
                            }
                        </div>
                        <div className='col-sm-6 pt-2'>
                            <div className="d-grid gap-2">
                                <button type="button" onClick={() => this.handleModalClose("showModal1")} className="btn redButton btn-lg">Close</button>
                            </div>
                        </div>
                    </div>
                </SmallModal>
                {/* modal Balance final*/}
            </div >
        )
    }
}